// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "scripts/" + (chunkId === 123 ? "icons" : chunkId) + "-" + {"118":"fd66f5","123":"0ed1e2","594":"9de3d7","633":"097058","732":"8f08ef"}[chunkId] + ".js";
};